/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SessionData } from './SessionData';
export type Session = {
    /**
     * Unique ID of this session.
     */
    sessionID: string;
    /**
     * Session owner's employee ID.
     */
    sessionOwnerOperatorID?: string;
    /**
     * Session owner's user ID.
     */
    sessionOwnerUserID?: string;
    /**
     * Session owner's company ID.
     */
    sessionOwnerCompanyID: string;
    /**
     * Session owner's store ID.
     */
    sessionOwnerStoreID?: string;
    /**
     * List of all the sata of this session.
     */
    sessionData?: Array<SessionData>;
    /**
     * Session status.
     */
    sessionStatus: Session.sessionStatus;
    /**
     * Time of the last update of patient data.
     */
    lastUpdated?: string;
};
export namespace Session {
    /**
     * Session status.
     */
    export enum sessionStatus {
        SESSION_STATUS_INVALID = 'SESSION_STATUS_INVALID',
        SESSION_STATUS_SESSION_CREATED = 'SESSION_STATUS_SESSION_CREATED',
        SESSION_STATUS_MEASUREMENT_DATA_CAPTURED = 'SESSION_STATUS_MEASUREMENT_DATA_CAPTURED',
        SESSION_STATUS_PRESCRIPTION_CREATED = 'SESSION_STATUS_PRESCRIPTION_CREATED',
        SESSION_STATUS_PRESCRIPTION_UPDATED = 'SESSION_STATUS_PRESCRIPTION_UPDATED',
        SESSION_STATUS_PRESCRIPTION_COMPLETED = 'SESSION_STATUS_PRESCRIPTION_COMPLETED',
        SESSION_STATUS_ORDER_CREATED = 'SESSION_STATUS_ORDER_CREATED',
        SESSION_STATUS_ORDER_CANCELLED = 'SESSION_STATUS_ORDER_CANCELLED',
        SESSION_STATUS_ORDER_DELIVERED = 'SESSION_STATUS_ORDER_DELIVERED',
        SESSION_STATUS_REPAIR_ORDER_CREATED = 'SESSION_STATUS_REPAIR_ORDER_CREATED',
    }
}

